import {fuseSettingsSlice} from '@fuse/core/FuseSettings/fuseSettingsSlice';
import {combineSlices, Reducer} from '@reduxjs/toolkit';
import {i18nSlice} from 'app/store/i18nSlice';

import {addKidApi} from '@/dataSource/src/api/add-kid/api';
import {cardsApi} from '@/dataSource/src/api/cards/api';
import {cardsThemeApi} from '@/dataSource/src/api/cards-theme/api';
import {editInfoApi} from '@/dataSource/src/api/editInfo/api';
import {splitBillsGroupsApi} from '@/dataSource/src/api/groups/api';
import {kycApi} from '@/dataSource/src/api/kyc/api';
import {paymentLinkApi} from '@/dataSource/src/api/payment-link/api';
import {paymentLinkV2Api} from '@/dataSource/src/api/payment-link/v2/api';
import {splitBillsApi} from '@/dataSource/src/api/split-bills/api';
import {splitsApi} from '@/dataSource/src/api/splits/api';
import {usersApi} from '@/dataSource/src/api/users/api';

import apiService from './apiService';
import {authSlice} from './authSlice';
import {responsiveSlice} from './responsiveSlice';
import {tokenSlice} from './tokenSlice';

// eslint-disable-next-line
// @ts-ignore
export interface LazyLoadedSlices {}

// `combineSlices` automatically combines the reducers using
// their `reducerPath`s, therefore we no longer need to call `combineReducers`.

export const rootReducer: Reducer = combineSlices(
  /**
   * Static slices
   */
  authSlice,
  tokenSlice,
  responsiveSlice,
  fuseSettingsSlice,
  i18nSlice,
  /**
   * Dynamic slices
   */
  {
    [apiService.reducerPath]: apiService.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [cardsApi.reducerPath]: cardsApi.reducer,
    [addKidApi.reducerPath]: addKidApi.reducer,
    [cardsThemeApi.reducerPath]: cardsThemeApi.reducer,
    [kycApi.reducerPath]: kycApi.reducer,
    [paymentLinkApi.reducerPath]: paymentLinkApi.reducer,
    [paymentLinkV2Api.reducerPath]: paymentLinkV2Api.reducer,
    [splitBillsApi.reducerPath]: splitBillsApi.reducer,
    [splitsApi.reducerPath]: splitsApi.reducer,
    [splitBillsGroupsApi.reducerPath]: splitBillsGroupsApi.reducer,
    [editInfoApi.reducerPath]: editInfoApi.reducer,
  },
).withLazyLoadedSlices<LazyLoadedSlices>();
